import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import { S } from './styles';

import './styles.css';
import Button from '../Button';
import Icon from '../Icon';

class Modal extends Component {
  componentDidMount() {
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.body.style.overflow = 'visible';
  }

  _onBackdropClick = () => {
    const { onBackdropClick } = this.props;
    onBackdropClick && onBackdropClick();
  };

  _sizeClassName = () => {
    switch (this.props.size) {
      case 'small':
        return 'Modal__window--small';
      case 'large':
        return 'Modal__window--large';
      default:
        return '';
    }
  };

  render() {
    const {
      title,
      children,
      className,
      hasClose,
      onBackdropClick,
      renderHeader,
      secondaryHeader,
      removeHeader,
    } = this.props;

    if (!removeHeader) {
      return (
        <CSSTransition classNames="Modal" in appear timeout={400}>
          <div className="Modal__backdrop" onClick={this._onBackdropClick}>
            <S.StyledModal
              {...this.props}
              className={`Modal__window ${className || ''
                } ${this._sizeClassName()}`}
              onClick={e => e.stopPropagation()}
              style={this.props.layoutConfig}
            >
              {secondaryHeader ? (
                <div className="Modal__header__container_secondary">
                  <div className="Modal__header_secondary">
                    {title && <div className="Modal__title_secondary">{title}</div>}
                    {hasClose && (
                      <Button
                        className="Modal__closer_secondary"
                        onClick={onBackdropClick}
                      >
                        <Icon name="close" />
                      </Button>
                    )}
                  </div>
                  {renderHeader && renderHeader}
                </div>
              ) : (
                <div className="Modal__header__container">
                  <div className="Modal__header">
                    {title && <div className="Modal__title">{title}</div>}
                    {hasClose && (
                      <Button
                        className="Modal__closer"
                        skin="transparent"
                        onClick={onBackdropClick}
                      >
                        <Icon name="close" />
                      </Button>
                    )}
                  </div>
                  {renderHeader && renderHeader}
                </div>
              )}

              <div className="Modal__content">{children}</div>
            </S.StyledModal>
          </div>
        </CSSTransition>
      );
    } else {
      return (
        <CSSTransition classNames="Modal" in appear timeout={400}>
          <div className="Modal__backdrop" onClick={this._onBackdropClick}>
            <S.StyledModal
              {...this.props}
              className={`Modal__window ${className || ''
                } ${this._sizeClassName()}`}
              onClick={e => e.stopPropagation()}
              style={this.props.layoutConfig}
            >
              {renderHeader && renderHeader}
              <div className="">{children}</div>
            </S.StyledModal>
          </div>
        </CSSTransition>
      );
    }
  }
}

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  hasCloser: PropTypes.bool,
  onCloser: PropTypes.func,
  renderHeader: PropTypes.func,
  size: PropTypes.oneOf(['small', 'large']),
  layoutConfig: PropTypes.object,
  onBackdropClick: PropTypes.func,
  className: PropTypes.string,
};

export default Modal;
